import React, { useMemo } from "react";
import { Alert as AlertAntd, Col, Row, Typography } from "antd";
import { JoinedAlert } from "../../../types";
import { ReactComponent as MosquitoIconSvg } from "../../../assets/icons/MosquitoVector.svg";

const { Text } = Typography;

type Props = {
  item: JoinedAlert;
  onClick?: (id: string) => void;
};

const AlertDialog: React.FC<Props> = ({ item }) => {
  const { date, hour } = useMemo(() => {
    const createdAt = item.created_at;
    if (!createdAt) return { date: "", hour: "" };

    const d = new Date(
      createdAt +
        (createdAt.endsWith("+00:00") || createdAt.toLowerCase().endsWith("z")
          ? ""
          : "+00:00"),
    );

    const dateString = d
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
      .replace(" at ", ",");

    const [datePart, hourPart] = dateString.split(",");

    return { date: datePart, hour: hourPart };
  }, [item.created_at]);

  const message = (item?.message || "").replace(/^\[.+\]/, "");

  return (
    <div key={item?._id} className="alert-dialog-container">
      <AlertAntd
        // onClick={() => onClick && onClick(item?._id)}
        message={
          <Col>
            <Row>
              <Text strong>{message}</Text>
            </Row>
            {item?.trap_name && (
              <Row>
                <Text>{item?.trap_name} </Text>
              </Row>
            )}
            <Row>
              <Text>{item?.device_name} </Text>
            </Row>
            <Row>
              <Text>{date} </Text>
            </Row>
            <Row>
              <Text>{hour}</Text>
            </Row>
          </Col>
        }
        type="warning"
        showIcon
        icon={<MosquitoIconSvg width={24} height={24} fill="#F97316" />}
      />
    </div>
  );
};

export default AlertDialog;
